import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import { UserService } from '../../../../core/user.service';
import { CqmnsProjectPopupComponent } from "../../../../_models/cqmns-project-popup/cqmns-project-popup.component";
import {MatDialog, MatDialogConfig} from "@angular/material";
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-cqmns-upload-excel-defect',
  templateUrl: './cqmns-upload-excel-defect.component.html',
  styleUrls: ['./cqmns-upload-excel-defect.component.css']
})
export class CqmnsUploadExcelDefectComponent implements OnInit {
  userId: any;

  constructor(private http: HttpClient, private route: ActivatedRoute, private userService: UserService, private authService: AuthService, 
    private matDialog: MatDialog) { }

  display = 'none';
  uploaded: boolean;
  showDownload: boolean;
  downloadLink="";
  projectId:any;
  hostUrl =this.userService.getUrl();
  filesToUpload: Array<File> = [];
  obj:any;
  project:any;
  projectName:any;
  ufileName:any;
    ngOnInit() {
      this.authService.user() .subscribe(
        data => {});
        this.userId = localStorage.getItem("userid");

      this.projectId = localStorage.getItem("projectId");
      this.uploaded = false;
        this.showDownload = false
        this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/activatedProjects/" + this.projectId
        )
      )
      .subscribe(data => {
        this.project = data;
        for (let i = 0; i <= this.project.length; i++) {
          if(this.project[i]){
        this.projectName = this.project[i].project_name;
        }
      }
      });
    }
  upload() {
      this.uploaded = false;
      this.showDownload = true;

    const formData: any = new FormData();
    const files: Array<File> = this.filesToUpload;
    console.log(files)

    for (let i = 0; i < files.length; i++) {
      formData.append('uploads[]', files[i], files[i]['name']);
    }
    this.http.post(this.hostUrl + '/file/upload/'+ this.projectId, formData)
      .subscribe(data => {
          
          this.obj = JSON.parse(JSON.stringify(data));
          this.downloadLink=this.hostUrl + '/download/'+this.obj.filename+'.csv';
          
          this.showDownload = false;
          this.uploaded = true;
      });

  }

  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
    let ufile = fileInput.target.files[0];
    this.ufileName = ufile.name;
    console.log(this.ufileName)
  }

  onNavigate(){
    window.open(this.downloadLink, "_blank");
}

onTemplateDownload()
{
   window.open(this.hostUrl + '/template.xlsx');
}
projectPopup() {
    

  const dialogConfig = new MatDialogConfig();

  // dialogConfig.panelClass = "login-modalbox";

  dialogConfig.backdropClass = 'popupBackdropClass';

  dialogConfig.maxHeight = window.innerHeight - 20 + 'px' ; 

  dialogConfig.panelClass = "ns-modalbox";
  dialogConfig.disableClose = false;
  this.matDialog.open(CqmnsProjectPopupComponent, dialogConfig);

}

}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-actions/cqmns-upload-excel-defect/cqmns-upload-excel-defect.component.ts